"use client"

import { useState, useEffect } from "react"
import Header from "./components/Header"
import Footer from "./components/Footer"
import AppContent from "./components/AppContent"

export default function DesignSprintGuide() {
  const [activeSection, setActiveSection] = useState("voorbereiding")
  const [activeStep, setActiveStep] = useState(0)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  // Handle window resize for mobile menu
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && mobileMenuOpen) {
        setMobileMenuOpen(false)
      }
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [mobileMenuOpen])

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  return (
    <div className="game-selector-container">
      <Header mobileMenuOpen={mobileMenuOpen} toggleMobileMenu={toggleMobileMenu} currentPage="none" />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-content-inner">
              <h1 className="hero-title">🚀 Project Kick-off Flow Helper</h1>
              <p className="hero-subtitle">
                Jouw stapsgewijze gids van probleem naar oplossing - klik zelf je weg door het proces!
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="content-section">
          <div className="content-container">
            <AppContent
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
